// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.skitterbook-simulator-container {
    height: 100%;
    width: 100%;
    padding: 0.5rem;
}

div.skitterbook-simulator-inner-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
}

    div.skitterbook-simulator-inner-container > a {
        font-size: 10pt;
        opacity: 1;
        transition: opacity 0.5s ease 1s;
    }
`, "",{"version":3,"sources":["webpack://./src/Simulators/css/SkitterBookLiveSimulator.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;;IAEI;QACI,eAAe;QACf,UAAU;QACV,gCAAgC;IACpC","sourcesContent":["div.skitterbook-simulator-container {\r\n    height: 100%;\r\n    width: 100%;\r\n    padding: 0.5rem;\r\n}\r\n\r\ndiv.skitterbook-simulator-inner-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n    div.skitterbook-simulator-inner-container > a {\r\n        font-size: 10pt;\r\n        opacity: 1;\r\n        transition: opacity 0.5s ease 1s;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
